import { Box } from "@mui/material";
import React from "react";
import Layout from "../../components/Layout/Layout";
import classes from "../../styles/CheckinFormStyle";
import { AntTab, AntTabs } from "../../styles/ManageUserStyle";
import UploadBulkCalls from "./UploadBulkCalls";
import UploadSingleCall from "./UploadSingleCall";

const UploadCall = () => {
  const [value, setValue] = React.useState<number>(0);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Layout>
      <Box sx={{ px: "2rem" }}>
        <Box sx={classes.antTabBox}>
          <AntTabs value={value} onChange={handleChange} aria-label="ant example">
            <AntTab label="Upload Single" />
            <AntTab label="Upload Bulk" />
          </AntTabs>
        </Box>

        {value === 0 ? (
          <UploadSingleCall callType={"call"} />
        ) : (
          <UploadBulkCalls callType={"call"} />
        )}
      </Box>
    </Layout>
  );
};

export default UploadCall;
